export default "__VITE_ASSET__D3n3MJR6__"